module.exports = __webpack_public_path__ + "img/Philippines-5-hover.350ad709.jpg";